<template>
  <div
    class="ui basic segment"
    v-bind:class="{ loading: is_loading }"
    ref="container"
  >
    <viewer @set_data="set_data" @refresh="init" ref="viewer" />
    <arguments v-show="false" ref="arguments" />
    <environment-modal
      @environment_selected="environment_selected"
      ref="environment_modal"
    />
  </div>
</template>

<script>
// import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast /* success_toast */ } from "@/utils";
import filters from "@/filters";
// import { cloneDeep } from "lodash";
// import Vue from "vue";
import Arguments from "./Arguments";
import Viewer from "./Viewer";
import EnvironmentModal from "./environment_modal/Index";

export default {
  name: "NgineComposerHumanTaskTester",
  filters: filters,
  components: {
    // GenericContainer,
    Arguments,
    Viewer,
    EnvironmentModal,
  },
  data() {
    return {
      is_loading: false,
      human_task: undefined,
    };
  },
  computed: {},
  methods: {
    init() {
      let vm = this;

      /** Get human task data */
      let projectUuid = this.$route.query.j;
      let humanTaskUuid = this.$route.query.h;

      if (projectUuid && humanTaskUuid) {
        vm.is_loading = true;
        local_api(vm, "post", "/ngine_composer/human_task/do-get", {
          p: projectUuid,
          h: humanTaskUuid,
        })
          .then((resp) => {
            // let vm = this;

            if (resp) {
              let ht = resp.human_task;
              let variables = resp.variables;
              vm.human_task = ht;
              // if (ht) {
              //   vm.$refs.viewer.init(ht);
              // } else error_toast(vm.$t("no human task"));

              if (variables) {
                vm.$refs.environment_modal.show_modal(variables);
              } else error_toast(vm.$t("no variables"));
            } else {
              error_toast(vm.$t("no response received"));
            }
          })
          .catch((err) => {
            error_toast(err);
          })
          .finally(() => {
            vm.is_loading = false;
          });
      } else {
        error_toast(this.$t("no project"));
      }
    },
    set_data(data) {
      let vm = this;
      vm.$refs.arguments.init(data);
    },
    environment_selected(environment) {
      let vm = this;
      if (vm.human_task) {
        vm.$refs.viewer.init({
          human_task: vm.human_task,
          environment: environment,
        });
      } else error_toast(vm.$t("no human task"));
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
  created() {},
  watch: {},
};
</script>

<style>
.pusher {
  margin-top: unset;
}

div#html_editor {
  width: 100%;
  min-height: 500px;
}
</style>
